import React from 'react';
import { FlexColumn, FlexRow, formatNumber } from '@make-software/tg-mini-app-ui';

import { formatDate, formatTime } from '@/utils';
import { VoteTransactionActivity } from '@/entities';
import { ProjectLogo, ProjectLogoContainer, StyledEarnIcon, Badge } from '@/shared';
import EarnIcon from '@/shared/assets/icons/ic-earn.svg';

import {
  ActivityPoints,
  FullWidthRow,
  ProjectStatusDetails,
  ProjectTitle,
  RoundActivityCardContainer
} from '../styled';

interface IRoundActivityCardProps {
  projectName: string;
  projectLogo: string;
  bgColor?: string;
  earnIconFill?: string;
  logoSize?: number;
  'aria-label'?: string;
  activity: VoteTransactionActivity;
}

export const RoundActivityCard: React.FC<IRoundActivityCardProps> = ({
                                                                       projectName,
                                                                       projectLogo,
                                                                       bgColor,
                                                                       earnIconFill = '#FB6F6A',
                                                                       logoSize = 42,
                                                                       activity,
                                                                       'aria-label': ariaLabel
                                                                     }) => {
  const dateText = formatDate(activity.created_at ?? '');
  const timeText = formatTime(activity.created_at ?? '');

  return (
    <RoundActivityCardContainer bgColor={bgColor} aria-label={ariaLabel}>
      <FullWidthRow align="center" justify="space-between">
        <FlexRow align="center" gap={10}>
          <ProjectLogoContainer width={logoSize} height={logoSize}>
            <ProjectLogo src={projectLogo} alt={`${projectName} logo`} size={60} />
          </ProjectLogoContainer>

          <FlexColumn>
            <ProjectTitle weight={3} color="#FFFFFF">
              {projectName}
            </ProjectTitle>

            {(dateText || timeText) && (
              <FlexRow align="center" gap={8}>
                {dateText && <ProjectStatusDetails weight={3}>{dateText}</ProjectStatusDetails>}
                {timeText && <ProjectStatusDetails weight={3}>{timeText}</ProjectStatusDetails>}
                {activity?.isExpired && <Badge status="expired" />}
                {activity?.isPending && <Badge status="pending" />}
              </FlexRow>
            )}
          </FlexColumn>
        </FlexRow>

        <FlexRow align="center" gap={5}>
          <StyledEarnIcon src={EarnIcon} size={20} fillColor={earnIconFill} />
          <ActivityPoints
            weight={3}
            color={activity?.isExpired ? '#6B7280' : '#FFFFFF'} // if expired use gray
            aria-label={`${projectName} votes ${activity?.token_amount}`}
          >
            {formatNumber(activity?.token_amount)}
          </ActivityPoints>
        </FlexRow>
      </FullWidthRow>
    </RoundActivityCardContainer>
  );
};
